// extracted by mini-css-extract-plugin
export var styles = "sidebar-module--styles--3Fmdw";
export var zzz = "sidebar-module--zzz--6zAhC";